export default "__VITE_ASSET__BRMFd9ZH__"